import { useTranslation } from 'react-i18next'
import { AuroraCirculationPumpMode } from '../enums'
import { MouseEvent } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import AuroraControl from './AuroraControl'

export interface AuroraCirculationPumpModeControlProps {
  value: AuroraCirculationPumpMode
  loading?: boolean
  disabled?: boolean
  onSubmit: (mode: AuroraCirculationPumpMode) => Promise<void>
}

export default function AuroraCirculationPumpModeControl({
  value,
  loading = false,
  disabled = false,
  onSubmit
}: AuroraCirculationPumpModeControlProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('aurora')

  /**
   * Handle the change event.
   */
  async function handleChange(_: MouseEvent<HTMLElement>, newValue: AuroraCirculationPumpMode) {
    try {
      await onSubmit(newValue)
    } catch {
      // Ignore the error.
    }
  }

  return (
    <AuroraControl
      direction="column"
      label={t('circulationPumpMode')}
      loading={loading}
      disabled={disabled}
      control={
        <ToggleButtonGroup
          color="primary"
          value={value}
          sx={{ mt: 2 }}
          exclusive
          disabled={disabled}
          onChange={handleChange}
        >
          <ToggleButton value={AuroraCirculationPumpMode.OFF}>{t('off')}</ToggleButton>
          <ToggleButton value={AuroraCirculationPumpMode.AUTO}>{t('auto')}</ToggleButton>
          <ToggleButton value={AuroraCirculationPumpMode.MAX}>{t('max')}</ToggleButton>
          <ToggleButton value={AuroraCirculationPumpMode.MIN}>{t('min')}</ToggleButton>
        </ToggleButtonGroup>
      }
    />
  )
}
